import Typography from "@mui/material/Typography";
import BoxContent from "../../../../shared/ui/BoxContent";
import moment from "moment/moment";
import React from "react";
import {ReportData} from "./ClassroomStandardsReport";

const ReportDescription = ({report, isStandard = false}: { report: ReportData, isStandard: boolean }) => {

    return (
        <>
            <Typography variant="h1" mb={2} mt={4}>Ce conține acest raport?</Typography>

            {isStandard ? (
                <BoxContent color="light" sxExtra={{breakAfter: "always", pageBreakAfter: "always"}}>

                    <Typography variant="body1">Acest raport conține datele rezultate în urma testării elevilor clasei
                        <strong> ({report.payload.classroom_grade}) {report.payload.classroom_name}</strong> în
                        perioada<strong> {`${moment(report?.start_date).locale("ro").format("DD.MM.YYYY")} – 
                    ${moment(report?.end_date).locale("ro").format("DD.MM.YYYY")}`}</strong>, pentru disciplina
                        <strong> {report.subject}</strong>.
                    </Typography>

                    <Typography variant="body1">
                        În paginile următoare sunt prezentate rezultatele elevilor în termeni de categorii de
                        performanță în care s-au încadrat notele obținute de aceștia pe fiecare conținut testat.
                    </Typography>

                    <Typography variant="h4" mb={1}>Interpretarea categoriilor de performanță:</Typography>

                    <Typography variant="body1" ml={3} mb={0.2}>
                        <strong>A</strong> – Performanță ridicată (note peste 7):
                        marcate cu <strong>verde</strong>
                    </Typography>
                    <Typography variant="body1" ml={3} mb={0.2}>
                        <strong>B</strong> – Nivel mediu (note între 5 și 7): marcat
                        cu <strong>albastru</strong>
                    </Typography>
                    <Typography variant="body1" ml={3}>
                        <strong>C</strong> – Performanță scăzută (note sub 5):
                        marcate cu <strong>roz</strong>
                    </Typography>
                    <Typography variant="body1">
                        În tabelul de la finalul raportului, pentru fiecare conținut testat, sunt selectați și
                        prezentați toți elevii care au obținut o notă încadrată în categoria C - Performanță scăzută,
                        alături de nota exactă obținută pe conținutul respectiv.
                    </Typography>

                    <Typography variant="h4" mb={1}>Cum se utilizează acest raport?</Typography>

                    <Typography variant="body1">Scopul raportului este <strong>sprijinirea organizării de activități
                        remediale</strong> și <strong>identificarea elevilor care necesită sprijin
                        suplimentar</strong> pentru recuperarea decalajelor de învățare.
                    </Typography>
                    <Typography variant="body1">
                        <strong>Pași recomandați pentru utilizare:</strong>
                    </Typography>
                    <Typography variant="body1" ml={3} mb={0.2}>
                        1. Examinați graficul pentru o imagine de ansamblu a distribuției performanțelor pe conținut.
                    </Typography>

                    <Typography variant="body1" ml={3} mb={0.2}>
                        2. Consultați Tabelul 1 pentru a identifica elevii care se află în
                        categoria <strong>C</strong> pentru fiecare conținut.
                    </Typography>

                    <Typography variant="body1" ml={3} mb={0.2}>
                        3. Utilizați aceste informații pentru a alcătui <strong>grupuri de lucru</strong> specifice
                        fiecărui conținut, în funcție de nevoile identificate.
                    </Typography>
                    <Typography variant="body1" ml={3}>
                        4. Planificați activități remediale personalizate pentru elevii identificați, cu accent pe acel
                        conținut unde s-au înregistrat cele mai multe dificultăți.
                    </Typography>

                    <Typography variant="body1">
                        Acest tip de raport permite luarea unor decizii informate privind intervențiile educaționale și
                        susține procesul de învățare adaptată la nevoile fiecărui elev.
                    </Typography>
                </BoxContent>
            ) : (
                <BoxContent color="light" sxExtra={{breakAfter: "always", pageBreakAfter: "always"}}>

                    <Typography variant="body1">Acest raport conține datele rezultate în urma testării elevilor clasei
                        <strong> ({report.payload.classroom_grade}) {report.payload.classroom_name}</strong> în
                        perioada<strong> {`${moment(report?.start_date).locale("ro").format("DD.MM.YYYY")} – 
                    ${moment(report?.end_date).locale("ro").format("DD.MM.YYYY")}`}</strong>, pentru disciplina
                        <strong> {report.subject}</strong>.
                    </Typography>

                    <Typography variant="body1">
                        În paginile următoare sunt prezentate rezultatele elevilor în termeni de categorii de
                        performanță în care s-au încadrat scorurile obținute de aceștia pe fiecare capitol testat.
                    </Typography>

                    <Typography variant="h4" mb={1}>Interpretarea categoriilor de performanță:</Typography>

                    <Typography variant="body1" ml={3} mb={0.2}>
                        <strong>A</strong> și <strong>B</strong> – Performanță ridicată (scoruri peste 70):
                        marcate cu <strong>verde</strong>
                    </Typography>
                    <Typography variant="body1" ml={3} mb={0.2}>
                        <strong>C</strong> – Nivel mediu (scoruri între 51 și 70): marcat cu <strong>albastru</strong>
                    </Typography>
                    <Typography variant="body1" ml={3}>
                        <strong>D</strong> și <strong>E</strong> – Performanță scăzută (scoruri sub 51):
                        marcate cu <strong>roz</strong>
                    </Typography>
                    <Typography variant="body1">
                        În tabelul de la finalul raportului, pentru fiecare capitol testat, sunt selectați și
                        prezentați toți elevii care au obținut un scor încadrat într-una din categoriile D sau
                        E, alături de scorul exact obținut pe capitolul respectiv.
                    </Typography>

                    <Typography variant="h4" mb={1}>Cum se utilizează acest raport?</Typography>
                    <Typography variant="body1">Scopul raportului este <strong>sprijinirea organizării de activități
                        remediale</strong> și <strong>identificarea elevilor care necesită sprijin
                        suplimentar</strong> pentru recuperarea decalajelor de învățare.
                    </Typography>

                    <Typography variant="body1">
                        <strong>Pași recomandați pentru utilizare:</strong>
                    </Typography>

                    <Typography variant="body1" ml={3} mb={0.2}>
                        1. Examinați graficul pentru o imagine de ansamblu a distribuției performanțelor pe capitol.
                    </Typography>

                    <Typography variant="body1" ml={3} mb={0.2}>
                        2. Consultați Tabelul 1 pentru a identifica elevii care se află în
                        categoriile <strong>D</strong> și <strong>E</strong> pentru fiecare capitol.
                    </Typography>
                    <Typography variant="body1" ml={3} mb={0.2}>
                        3. Utilizați aceste informații pentru a alcătui <strong>grupuri de lucru</strong> specifice
                        fiecărui capitol, în funcție de nevoile identificate.
                    </Typography>
                    <Typography variant="body1" ml={3}>
                        4. Planificați activități remediale personalizate pentru elevii identificați, cu accent pe acele
                        capitole unde s-au înregistrat cele mai multe dificultăți.
                    </Typography>

                    <Typography variant="body1">
                        Acest tip de raport permite luarea unor decizii informate privind intervențiile educaționale și
                        susține procesul de învățare adaptată la nevoile fiecărui elev.
                    </Typography>
                </BoxContent>
            )}


        </>
    )
}

export default ReportDescription;